import React, { memo } from "react";
import "../../pages/Project/ProjectPage.css";
import { ButtomGet } from "../ButtomGet/ButtomGet";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";

const proyectImg = require.context("../../img", true);

const projects = [
  {
    img: "proyecto-6.jpg",
    title: "Clasher's Den",
    desc: "Discord Bot",
    tech: ["HTML5", "CSS3", "JavaScript", "Bootstrap"],
    repo: "https://github.com/abhayclasher",
  },
  {
    img: "shoes.png",
    title: "Sneaking",
    desc: "Shoes Website ",
    tech: ["HTML5", "CSS3", "JavaScript", "Bootstrap"],
    repo: "https://github.com/abhayclasher",
  },
  {
    img: "ecom.jpg",
    title: "Anant Store",
    desc: "Ecommerce",
    tech: ["HTML5", "CSS3", "Sass", "JavaScript"],
    repo: "https://github.com/abhayclasher",
  },
  {
    img: "ind.jpg",
    title: "IND Community",
    desc: "Showcase IND",
    tech: ["HTML5", "CSS3", "JavaScript"],
    repo: "https://github.com/abhayclasher",
  },
];

const Project = () => (
  <section className="proyectos" id="proyectos" data-aos="fade-up">
    <h2 className="heading">Projects</h2>

    <Swiper
      spaceBetween={30}
      loop
      grabCursor
      speed={600}
      centeredSlides
      autoplay={{ delay: 2500, disableOnInteraction: false }}
      pagination={{ clickable: true }}
      modules={[Pagination, Autoplay]}
      breakpoints={{
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }}
      className="proyectos-slider mySwiper"
    >
      {projects.map((p, i) => (
        <SwiperSlide className="caja" key={i}>
          <img src={proyectImg(`./${p.img}`)} alt={p.title} loading="lazy" />
          <div className="content">
            <h3>{p.title}</h3>
            <p>{p.desc}</p>
            <p className="tecnologias">
              {p.tech.map((t, idx) => (
                <React.Fragment key={t}>
                  {t}
                  {idx < p.tech.length - 1 && <span>-</span>}
                </React.Fragment>
              ))}
            </p>
            <a
              href="https://github.com/abhayclasher"
              className="custom-btn btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Demo</span>
            </a>
            <a
              href={p.repo}
              className="custom-btn btn-codigo"
              target="_blank"
              rel="noopener noreferrer"
            >
              Repository
            </a>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>

    <div className="portafolio-btn">
      <a
        href="https://github.com/abhayclasher"
        target="_blank"
        rel="noopener noreferrer"
      >
        <ButtomGet />
      </a>
    </div>
  </section>
);

export default memo(Project);
